import React from 'react'
// import { ReactComponent as HomeIcon } from 'src/assets/icon/home-icon.svg'
// import { ReactComponent as ChatIcon } from 'src/assets/icon/chat-icon.svg'
// import { ReactComponent as CategoryIcon } from 'src/assets/icon/category-icon.svg'
// import { ReactComponent as ShopCartIcon } from 'src/assets/icon/shopcart-icon.svg'
// import { ReactComponent as AccountIcon } from 'src/assets/icon/account-icon.svg'
import useStyles from './useStyles'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import AccountDropDownForFooter from '../AccountDropDownForFooter'
import HomeSrc from 'src/assets/img/Home.png'
import CartSrc from 'src/assets/img/Cart.png'
interface Props {
  setPassOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const Footer: React.FC<Props> = ({ setPassOpen }) => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.footer}>
      <ul className={classes.footerMenus}>
        <Link to='/home'>
          <li className={classes.footerListItems}>
            <img src={HomeSrc} alt='' />
            {t('global7')}
          </li>
        </Link>
        {/* <li>
          <ChatIcon />
          {t('global3')}
        </li> */}
        {/* <li className={classes.footerListItems}>
          <CategoryIcon />
          {t('global4')}
        </li> */}
        <Link to='/pages/cart'>
          <li className={classes.footerListItems}>
            {/* <ShopCartIcon /> */}
            <img src={CartSrc} alt='' />
            {t('global5')}
          </li>
        </Link>
        <li className={classes.footerListItems}>
          {/* <AccountIcon /> */}
          <AccountDropDownForFooter setPassOpen={setPassOpen} />
        </li>
      </ul>
    </div>
  )
}

export default Footer
